import React, { useState } from 'react';

// helpers
import useUserAccess from 'hooks/useUserAccess';
import useTranslation from 'hooks/useTranslation';

// components
import { PageButton, Col, Row, Text } from '@ui';
import ApprovalGroupsTable from './ApprovalGroupsTable';
import AddApprovalGroupModal from './AddApprovalGroupModal';
import EditApprovalGroupModal from './EditApprovalGroupModal';

const ApprovalGroupsTab = () => {
  const { t } = useTranslation('account_management');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);
  const [updateTableTrigger, updateTable] = useState({});

  const [hasCreateAccess, hasEditAccess] = useUserAccess([
    'AccountManagement_TransactionRules_ApprovalGroups_Create',
    'AccountManagement_TransactionRules_ApprovalGroups_Edit',
  ]);

  const handleAddGroupClick = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = (shouldUpdate?: boolean) => {
    shouldUpdate && updateTable({});
    setIsModalVisible(false);
  };

  const handleCloseEditModal = (shouldUpdate?: boolean) => {
    shouldUpdate && updateTable({});
    setSelectedGroup(null);
  };

  const handleOnActionsClick = (key: string, groupId: string) => {
    switch (key) {
      case 'edit':
        setSelectedGroup(groupId);
        break;
    }
  };

  return (
    <>
      <Text variant="body1" gutterBottom>
        {t('transaction_rules.approval_groups_description')}
      </Text>

      {hasCreateAccess && (
        <Row justify="end">
          <Col flex="150px">
            <PageButton fullWidth onClick={handleAddGroupClick}>
              {t('approval_groups.add_group_button')}
            </PageButton>
          </Col>
        </Row>
      )}

      <ApprovalGroupsTable
        onActionsClick={handleOnActionsClick}
        updateTableTrigger={updateTableTrigger}
        hasPermissionForEditing={hasEditAccess}
      />

      {hasCreateAccess && (
        <AddApprovalGroupModal
          isVisible={isModalVisible}
          closeCallback={handleModalClose}
        />
      )}

      {hasEditAccess && (
        <EditApprovalGroupModal
          isVisible={!!selectedGroup}
          closeCallback={handleCloseEditModal}
          groupId={selectedGroup as string}
        />
      )}
    </>
  );
};

export default ApprovalGroupsTab;
